import {
    QidModel,
    QidModelSafetyFunction,
    QidModelOption,
} from "server/models"
import {
    inferLiteral,
    QidCalculationMethod,
    QidCalculationFormat,
} from "client/utils"
import { ResultDatapointListType } from "client/store"
import * as types from "./types"


export const setQidResultDatapointList = (datapointList: ResultDatapointListType) => ({
    type: inferLiteral(types.QID_RESULT_DATAPOINT_LIST),
    datapointList,
})


export const setQidResultCalculationMethod = (calculationMethod: QidCalculationMethod) => ({
    type: inferLiteral(types.QID_RESULT_CALCULATION_METHOD),
    calculationMethod,
})
export const setQidResultFormat = (format: QidCalculationFormat) => ({
    type: inferLiteral(types.QID_RESULT_FORMAT),
    format,
})
export const setQidResultDecimal = (decimal: number) => ({
    type: inferLiteral(types.QID_RESULT_DECIMAL),
    decimal,
})


export const setQidResultModelIds = (modelIds: number[]) => ({
    type: inferLiteral(types.QID_RESULT_MODEL_IDS),
    modelIds,
})
export const setQidResultModel = (model: QidModel) => ({
    type: inferLiteral(types.QID_RESULT_MODEL),
    model,
})
export const setQidResultSafetyFunction = (safetyFunction: QidModelSafetyFunction) => ({
    type: inferLiteral(types.QID_RESULT_SAFETY_FUNCTION),
    safetyFunction,
})
export const setQidResultOption = (option: QidModelOption) => ({
    type: inferLiteral(types.QID_RESULT_OPTION),
    option,
})


export const setQidResultExpandedModelIds = (modelIds: number[]) => ({
    type: inferLiteral(types.QID_RESULT_EXPANDED_MODEL_IDS),
    modelIds,
})
export const setQidResultExpandedSafetyFunctionIds = (safetyFunctionIds: number[]) => ({
    type: inferLiteral(types.QID_RESULT_EXPANDED_SAFETY_FUNCTION_IDS),
    safetyFunctionIds,
})
export const setQidResultExpandedOptionIds = (optionIds: number[]) => ({
    type: inferLiteral(types.QID_RESULT_EXPANDED_OPTION_IDS),
    optionIds,
})
